module.exports = __webpack_public_path__ + "img/auth.ab3fcd36.jpg";